import $http from "@/http/http";
//树
export const getDeviceLedgerTree = data => {
    return $http.post("/collect/device_ledger/getDeviceLedgerTree", data);
};
//分页
export const getDeviceLedgerList = data => {
    return $http.post("/collect/device_ledger/getDeviceLedgerList", data);
};
//查单个
export const selectByDeviceLedgerId = data => {
    return $http.post("/collect/device_ledger/selectByDeviceLedgerId", data);
};
//删除
export const deleteDeviceLedger = data => {
    return $http.post("/collect/device_ledger/deleteDeviceLedger", data);
};
//保存
export const saveDeviceLedger = data => {
    return $http.post("/collect/device_ledger/saveDeviceLedger", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

export const savePowerSupplyTypeTree = data => {
    return $http.post("/collect/powerSupplyType/saveOrUpdate", data);
};

export const deletePowerSupplyAccountList = data => {
    return $http.post("/collect/powerSupplyAccount/delete", data);
};
